import { render } from "./ServicesSvg.vue?vue&type=template&id=8553fd1a"
const script = {}

import "./ServicesSvg.vue?vue&type=style&index=0&id=8553fd1a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__